<template>
  <v-container quoteDetails grid-list-xl style="margin-left:3%; margin-right:3%; max-width: 94%;">
    <v-layout wrap>
      <v-flex lg6 class="paddingBottomNone">
        <strong>Quote Date: </strong>
        <span v-if="singleQuoteData.quote.quote_date">&nbsp;&nbsp;{{ singleQuoteData.quote.quote_date }}</span>
        <span v-else>&nbsp;&nbsp;</span>
        <div style="margin-bottom: 2px;clear:both;"></div>
        <strong>Customer Name:</strong>&nbsp;&nbsp;{{ singleQuoteData.quote.customer_name }}
        <div style="margin-bottom: 2px;clear:both;"></div>
        <strong>Originator Name:</strong>
        <span v-if="singleQuoteData.quote.originator_name">&nbsp;&nbsp;{{ singleQuoteData.quote.originator_name }}</span>
        <span v-else>&nbsp;&nbsp;{{ singleQuoteData.quote.orig_name }}</span>
      </v-flex>
      <v-flex lg6 class="paddingBottomNone">
        <strong>Sales Order Number:</strong>
        <span>{{ fncShowSalesOrderNumber(singleQuoteData.quote.sales_order_number) }}</span>
        <div style="margin-bottom: 2px;clear:both;"></div>
        <strong v-if="globalModalParams.quoteDetails[0].deliveryType != ''">Delivery Type:</strong>
        <span v-if="globalModalParams.quoteDetails[0].deliveryType != ''">{{ globalModalParams.quoteDetails[0].deliveryType }}</span>
        <div v-if="globalModalParams.quoteDetails[0].deliveryType != ''" style="margin-bottom: 2px;clear:both;"></div>
        <strong v-if="globalModalParams.quoteDetails[0].addressDetails" v-html="fncGetLabel( globalModalParams.quoteDetails[0].deliveryType )"></strong>
        <span v-if="globalModalParams.quoteDetails[0].addressDetails">{{ globalModalParams.quoteDetails[0].addressDetails }}</span>
        <div v-if="globalModalParams.quoteDetails[0].addressDetails" style="margin-bottom: 2px;clear:both;"></div>
        <strong v-if="globalModalParams.quoteDetails[0].billingAddress != ''">Billing Address:</strong>
        <span v-if="globalModalParams.quoteDetails[0].billingAddress != ''">{{ globalModalParams.quoteDetails[0].billingAddress }}</span>
      </v-flex>
      <!--<v-flex lg12 class="paddingBottomNone">
        <strong>Customer Name:</strong>&nbsp;&nbsp;{{ singleQuoteData.quote.customer_name }}
      </v-flex>
      <v-flex lg12 class="paddingBottomNone">
        <strong>Originator Name:</strong>
        <span v-if="singleQuoteData.quote.originator_name">&nbsp;&nbsp;{{ singleQuoteData.quote.originator_name }}</span>
        <span v-else>&nbsp;&nbsp;{{ singleQuoteData.quote.orig_name }}</span>
      </v-flex>-->
      <v-flex lg12 class="userInfo">
        <!--<p v-if="singleQuoteData.details[0].price == '' || singleQuoteData.details[0].price == '0'"><strong>There is currently no data available for this Quote.  Please populate quote to display details here.</strong></p>-->
        <v-data-table :search="search" :items="singleQuoteData.details" class="middleTable minTable" style="font-size: 10px;" hide-actions>
          <template slot="headers" slot-scope="props">
            <tr class="middle">
              <th style="border: 1px solid #fff;">ITEM</th>
              <th style="border: 1px solid #fff;" v-if="objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1" colspan="2">QUANTITY</th>
              <th style="border: 1px solid #fff;" v-else>QUANTITY</th>
              <th style="border: 1px solid #fff;">UOM</th>
              <th v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" colspan="2" style="border: 1px solid #fff;" >UNIT PRICE</th>
              <th v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') === -1" style="border: 1px solid #fff;" >UNIT PRICE</th>
              <th v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" colspan="2" style="border: 1px solid #fff;" >TOTAL PRICE</th>
              <th v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') === -1" style="border: 1px solid #fff;" >TOTAL PRICE</th>
            </tr>
            <tr v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" class="smaller middle">
              <th style="border: 1px solid #fff;"></th>
              <th style="border: 1px solid #fff;" v-if="objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1" >Requested</th>
              <th style="border: 1px solid #fff;" v-if="objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1" >Actual</th>
              <th style="border: 1px solid #fff;" v-else width="14%"></th>
              <th style="border: 1px solid #fff;" ></th>
              <th v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" style="border: 1px solid #fff;" >Gross</th>
              <!--<th v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" style="border: 1px solid #fff;" >Discount</th>-->
              <th style="border: 1px solid #fff;" >Nett</th>
              <th v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" style="border: 1px solid #fff;" >Gross</th>
              <!--<th v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" style="border: 1px solid #fff;" >Discount</th>-->
              <th style="border: 1px solid #fff;">Nett</th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <td v-if="linkedProps.indexOf(props.item.p_key.toString()) == -1 && fncIsParent(props.item) == false" v-html="fncFilterNameFull(props.item, props.item.name, false)"></td>
            <td v-else v-html="fncFilterNameFull(props.item,props.item.name, true)"></td>
            <td class="text-xs-right" v-if="objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1">{{ props.item.quantity }}</td>
            <td class="text-xs-right" v-else>{{ props.item.quantity }}</td>
            <td class="text-xs-right v-else " v-if="objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1">{{ props.item.quantity_calc }}</td>
            <td>{{ fncFilterName(props.item.uom, false) }}</td>
            <td v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" class="text-xs-right ">{{ fncFilterPrice(props.item.price) }}</td>
            <!--<td v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" class="text-xs-right ">{{ fncFilterPrice(props.item.discount) }}</td>-->
            <td class="text-xs-right ">{{ fncFormatNett(props.item.price, props.item.discount) }}</td>
            <td v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" class="text-xs-right ">{{ fncFormatTotal(props.item.price, props.item.quantity_calc) }}</td>
            <!--<td v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" class="text-xs-right ">{{ fncFormatTotal(props.item.discount,props.item.quantity) }}</td>-->
            <td class="text-xs-right ">{{ fncFormatTotalNett(props.item.price, props.item.quantity_calc, props.item.discount, props.item.quantity) }}</td>
          </template>
          <template slot="footer" style="padding-bottom: 10px;margin-top: 40px;" v-if="objAuthorize.manufacturer != '385889803' && objAuthorize.manufacturer != '16777962'">
            <tr style="font-size: 12px !important; border: none !important; background-color: #fff !important; background: #fff !important; color: #000;">
              <td v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" colspan="7" class="text-xs-right" style="text-align: right !important;"><strong>NETT TOTAL</strong></td>
              <td v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') === -1" colspan="5" class="text-xs-right" style="text-align: right !important;"><strong>NETT TOTAL</strong></td>
              <td style="text-align: right !important;padding-right:2%;border-top: 1px solid #333 !important;">{{ fncTotalNett() }}</td>
            </tr>
            <tr style="font-size: 12px !important;  border: none !important;  background-color: #fff !important; background: #fff !important; color: #000;">
              <td v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" colspan="7" style="text-align: right !important;"><strong>VAT @ 15%</strong></td>
              <td v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') === -1" style="text-align: right !important;"><strong>VAT @ 15%</strong></td>
              <td style="text-align: right !important;padding-right:2%;border-bottom: 1px solid #333 !important;">{{ fncCalculateVat() }}</td>
            </tr>
            <tr style="margin-top: 3px;font-size: 12px !important; border: none !important; background-color: #fff !important; background: #fff !important; color: #000;">
              <td v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" colspan="7" style="text-align: right !important;"><strong>TOTAL PRICE</strong></td>
              <td v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') === -1" colspan="5" style="text-align: right !important;"><strong>TOTAL PRICE</strong></td>
              <td class="totalprice-column" style="text-align: right !important;">{{ fncFinalTotal() }}</td>
            </tr>

          </template>
          <template slot="footer" style="padding-bottom: 10px;margin-top: 40px;" v-if="objAuthorize.vendorActive == 1 && objAuthorize.manufacturer == '385889803'">
            <tr style="font-size: 12px !important; border: none !important; background-color: #fff !important; background: #fff !important; color: #000;">
              <td v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" colspan="7" style="text-align: right !important;"><strong>TOTAL PRICE</strong></td>
              <td v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') === -1" colspan="4" style="text-align: right !important;"><strong>TOTAL PRICE</strong></td>
              <td class="totalprice-column" style="text-align: right !important;">{{ fncTotalNett() }}</td>
            </tr>

          </template>
          <template slot="footer" style="padding-bottom: 10px;margin-top: 40px;" v-if="objAuthorize.manufacturer == '16777962'">
            <tr style="font-size: 12px !important; border: none !important; background-color: #fff !important; background: #fff !important; color: #000;">
              <td v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1" colspan="7" style="text-align: right !important;"><strong>TOTAL PRICE</strong></td>
              <td v-if="objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') === -1" colspan="4" style="text-align: right !important;"><strong>TOTAL PRICE</strong></td>
              <td class="totalprice-column" style="text-align: right !important;">{{ fncTotalNett() }}</td>
            </tr>

          </template>
        </v-data-table>
        <br />
        <div v-if="lineData.installation_customer_first_name != null" class="lineItemDetails">
          <br /><br /><h2>Installation Details</h2>
          <table cellpadding="10" width="100%" class="installation">
            <tr>
              <th class="installation-header" colspan="4"><strong>Customer Details</strong></th>
            </tr>
            <tr>
              <th width="25%">First Name</th>
              <th width="25%">Last Name</th>
              <th width="25%">Email Address</th>
              <th width="25%">Contact Number</th>
            </tr>
            <tr>
              <td width="25%">{{ lineData.installation_customer_first_name }}</td>
              <td width="25%">{{ lineData.installation_customer_last_name }}</td>
              <td width="25%">{{ lineData.installation_customer_email }}</td>
              <td width="25%">{{ lineData.installation_customer_contact_number }}</td>
            </tr>
          </table>
<br />
        <table cellpadding="10" width="100%" class="installation">
          <tr>
            <th class="installation-header" colspan="4"><strong>Address Details</strong></th>
          </tr>
          <tr>
            <th width="50%" colspan="2">Address Found</th>
            <th width="50%" colspan="2">Address Searched</th>
          </tr>
          <tr>
            <td width="50%" colspan="2">{{ lineData.installation_address_found }}</td>
            <td width="50%" colspan="2">{{ lineData.installation_address_searched }}</td>
          </tr>
          <tr>
            <th width="25%">Suburb</th>
            <th width="25%">Province</th>
            <th width="25%">Installation Lat</th>
            <th width="25%">Installation Long</th>
          </tr>
          <tr>
            <td width="25%">{{ lineData.installation_address_suburb }}</td>
            <td width="25%">{{ lineData.installation_address_province }}</td>
            <td width="25%">{{ lineData.installation_address_install_lat }}</td>
            <td width="25%">{{ lineData.installation_address_install_long }}</td>
          </tr>
          <tr>
            <th width="25%">Store Lat</th>
            <th width="25%">Store Long</th>
            <th width="25%">Store Name</th>
            <th width="25%">Store Code</th>
          </tr>
          <tr>
            <td width="25%">{{ lineData.installation_address_store_lat }}</td>
            <td width="25%">{{ lineData.installation_address_store_long }}</td>
            <td width="25%">{{ lineData.installation_address_store_name }}</td>
            <td width="25%">{{ lineData.store_id }}</td>
          </tr>
        </table>
        <br />
        <table cellpadding="10" width="100%" class="installation">
          <tr>
            <th class="installation-header" colspan="5"><strong>Install Details</strong></th>
          </tr>
          <tr>
            <th width="20%">Appointment Date Start</th>
            <th width="20%">Appointment Date End</th>
            <th width="20%">Appointment Contact Number</th>
            <th width="20%">Appointment Contact Person</th>
            <th width="20%">Lookup Service Rep</th>
          </tr>
          <tr>
            <td width="20%" v-html="fncDisplayDate(lineData.installation_appointment_date_start)"></td>
            <td width="20%">{{ lineData.installation_appointment_date_end }}</td>
            <td width="20%">{{ lineData.installation_appointment_contact_number }}</td>
            <td width="20%">{{ lineData.installation_appointment_contact_person }}</td>
            <td width="20%">{{ lineData.installation_lookup_service_ref }}</td>
          </tr>
          <tr>
            <th width="80%" colspan="4">Appointment Installation Notes</th>
            <th width="20%">Installation Sales Order Number</th>
          </tr>
          <tr>
            <td width="80%" colspan="4">{{ lineData.installation_notes }}</td>
            <td width="20%">{{ lineData.installation_sales_order_number }}</td>
          </tr>
        </table>
          <br />
          <table cellpadding="10" width="100%" class="installation">
            <tr>
              <th class="installation-header" colspan="6"><strong>Product Details</strong></th>
            </tr>
            <tr>
              <th width="16.66%">Product Description</th>
              <th width="16.66%">Product Make</th>
              <th width="16.66%">Product Type</th>
              <th width="16.66%">Product SKU</th>
              <th width="16.66%">Product MO ID</th>
              <th width="16.66%">Product QTY</th>
            </tr>
            <tr v-if="productCount >= 1">
              <td width="16.66%">{{ lineData.installation_product_description_1 }}</td>
              <td width="16.66%">{{ lineData.installation_product_make_1 }}</td>
              <td width="16.66%">{{ lineData.installation_product_type_1 }}</td>
              <td width="16.66%">{{ lineData.installation_product_sku_1 }}</td>
              <td width="16.66%">{{ lineData.installation_product_moid_1 }}</td>
              <td width="16.66%">{{ lineData.installation_product_qty_1 }}</td>
            </tr>
            <tr v-if="productCount >= 2">
              <td width="16.66%">{{ lineData.installation_product_description_2 }}</td>
              <td width="16.66%">{{ lineData.installation_product_make_2 }}</td>
              <td width="16.66%">{{ lineData.installation_product_type_2 }}</td>
              <td width="16.66%">{{ lineData.installation_product_sku_2 }}</td>
              <td width="16.66%">{{ lineData.installation_product_moid_2 }}</td>
              <td width="16.66%">{{ lineData.installation_product_qty_2 }}</td>
            </tr>
            <tr v-if="productCount >= 3">
              <td width="16.66%">{{ lineData.installation_product_description_3 }}</td>
              <td width="16.66%">{{ lineData.installation_product_make_3 }}</td>
              <td width="16.66%">{{ lineData.installation_product_type_3 }}</td>
              <td width="16.66%">{{ lineData.installation_product_sku_3 }}</td>
              <td width="16.66%">{{ lineData.installation_product_moid_3 }}</td>
              <td width="16.66%">{{ lineData.installation_product_qty_3 }}</td>
            </tr>
            <tr v-if="productCount >= 4">
              <td width="16.66%">{{ lineData.installation_product_description_4 }}</td>
              <td width="16.66%">{{ lineData.installation_product_make_4 }}</td>
              <td width="16.66%">{{ lineData.installation_product_type_4 }}</td>
              <td width="16.66%">{{ lineData.installation_product_sku_4 }}</td>
              <td width="16.66%">{{ lineData.installation_product_moid_4 }}</td>
              <td width="16.66%">{{ lineData.installation_product_qty_4 }}</td>
            </tr>
            <tr v-if="productCount >= 5">
              <td width="16.66%">{{ lineData.installation_product_description_5 }}</td>
              <td width="16.66%">{{ lineData.installation_product_make_5 }}</td>
              <td width="16.66%">{{ lineData.installation_product_type_5 }}</td>
              <td width="16.66%">{{ lineData.installation_product_sku_5 }}</td>
              <td width="16.66%">{{ lineData.installation_product_moid_5 }}</td>
              <td width="16.66%">{{ lineData.installation_product_qty_5 }}</td>
            </tr>
          </table>
          <br />
        </div>
        <div class="lineItemDetails">
          <!--<div class="lineItemDetail" v-html="item.spec" v-if="item.linked_props != '' || singleQuoteData.details.length == 1" v-for="(item, key) in singleQuoteData.details">-->
          <!--<div class="lineItemDetail" v-for="(item, key) in singleQuoteData.details">
            <div v-html="fncShowSpec(item.spec, key)"></div>
          </div>-->
          <div class="lineItemDetail" v-html="fncShowSpec(singleQuoteData.details)"></div>
        </div>
      </v-flex>
      <div class="pl-4 pr-4 pb-4 buttonHolder">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import {singleQuoteData} from "../../../store/modules/reports/getters";
  export default {
    name: 'Settings',
    data() {
      return {
        objUser: 0,
        search: '',
        totalNett: 0,
        totalVat: 0,
        totals: [],
        linkedProps: [],
        newSingleQuoteData: [],
        lineData: '',
        productCount: 0,
        quoteTotal: [],
        addedSpecs: [],
        isTallisman: false
      };
    },
    methods: {
      fncGetLabel( type ) {
        if( type == 'Collect' ) {
          return 'Collection Address';
        }
        return 'Delivery Address';
      },
      fncDisplayDate( dateString ) {
        var objDates = dateString.split(',');
        var toReturn = '<p>'+objDates[objDates.length - 1]+'</p>';
        if( objDates.length > 1 ) {
          toReturn += '<small><strong>OLD DATES</strong></small><br />';
          for( var d in objDates ) {
            if( objDates[d] != objDates[objDates.length - 1] ) {
              toReturn += '<small>'+objDates[d]+'</small><br />';
            }
          }
        }
        return toReturn;
      },
      fncShowSalesOrderNumber( soNumber ) {
        if( soNumber != '' && soNumber != '0' && soNumber != null && soNumber != 'null' ) {
          return soNumber;
        } else {
          return 'N/A';
        }
      },
      fncIsParent(data) {
        var line_data = JSON.parse(data.line_item_data);

        if (line_data.parent_prop == '' ) {
          return false;
        } else {
          return true;
        }
      },
      fncFilterNameFull(item, name, isProp) {

        var lineItemData =JSON.parse( item.line_item_data );

        var dataUrl = name.replace(/%20/g, " ");
        dataUrl = dataUrl.replace(/%27/g, "'");
        dataUrl = dataUrl.replace(/%3A/g, ":");
        dataUrl = dataUrl.replace(/%3B/g, ";");
        dataUrl = dataUrl.replace(/%3C/g, "<");
        dataUrl = dataUrl.replace(/%3D/g, "=");
        dataUrl = dataUrl.replace(/%3E/g, ">");
        dataUrl = dataUrl.replace(/%2C/g, ",");
        dataUrl = dataUrl.replace(/%28/g, "(");
        dataUrl = dataUrl.replace(/%29/g, ")");
        dataUrl = dataUrl.replace(/&sup/g, "");
        dataUrl = dataUrl.replace(/;/g, "");

        let toReturn = 'N/A';

        if( lineItemData.installationReferenceNumber != undefined && this.objAuthorize.privileges.indexOf('VIEW_INSTALLATION_REF') != -1 ) {
          if (isProp == true) {
            toReturn = '<span style="display: block; padding-left: 20px;">-&nbsp;&nbsp;' + dataUrl + '</span><br /><small style="display:block;width:100%;background:#efefef;text-align:center;padding:3px;"><strong>Installation Ref: '+lineItemData.installationReferenceNumber+'</strong></small>';
          } else {
            toReturn =  dataUrl + '<br /><small style="display:block;width:100%;background:#efefef;text-align:center;padding:3px;"><strong>Installation Ref: '+lineItemData.installationReferenceNumber+'</strong></small>';
          }
        } else {
          if (isProp == true) {
            toReturn =  '<span style="display: block; padding-left: 20px;">-&nbsp;&nbsp;' + dataUrl + '</span>';
          } else {
            if (item.code == '000000000000751223' || item.code == '751223') {
              if (lineItemData.hire_period != undefined) {
                if (lineItemData.hire_period > 1) {
                  toReturn =  lineItemData.hire_period + ' days';
                } else {
                  toReturn =  '1 day';
                }
              }
              toReturn =  '1 day';
            } else {
              toReturn = dataUrl;
            }
          }
        }

        toReturn = toReturn + '<small style="padding-left: 20px;font-size: 10px;"><strong>Article Number:</strong> '+item.code+'</small>';
        return toReturn;

      },
      fncFilterName(name, isProp) {

        var dataUrl = name.replace(/%20/g, " ");
        dataUrl = dataUrl.replace(/%27/g, "'");
        dataUrl = dataUrl.replace(/%3A/g, ":");
        dataUrl = dataUrl.replace(/%3B/g, ";");
        dataUrl = dataUrl.replace(/%3C/g, "<");
        dataUrl = dataUrl.replace(/%3D/g, "=");
        dataUrl = dataUrl.replace(/%3E/g, ">");
        dataUrl = dataUrl.replace(/%2C/g, ",");
        dataUrl = dataUrl.replace(/%28/g, "(");
        dataUrl = dataUrl.replace(/%29/g, ")");
        dataUrl = dataUrl.replace(/&sup/g, "");
        dataUrl = dataUrl.replace(/;/g, "");

        if (isProp == true) {
          return '<span style="display: block; padding-left: 20px;">-&nbsp;&nbsp;' + dataUrl + '</span>';
        } else {
          return dataUrl;
        }
      },
      fncHideModal() {
        this.$store.commit('hideModal');
      },
      fncFilterPrice(filterVar) {
        var currencyValue = parseFloat(filterVar).toFixed(2);
        currencyValue = currencyValue.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return 'R' + currencyValue;
      },
      fncFormatPerc(filterDiscount, ) {
        return parseFloat(filterVar).toFixed(2) + '%';
      },
      fncFormatNett(filterPrice, filterDiscount) {
        var finalPrice = parseFloat(parseFloat(filterPrice) - parseFloat(filterDiscount)).toFixed(2);
        var nettValue = finalPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return 'R' + nettValue;
      },
      fncFormatTotal(filterPrice, filterQty, item) {

        if( item != undefined && item != 'undefined' && ( item.code == '000000000000751223' || item.code == '751223' ) ) {

          var lineItemData = JSON.parse( item.line_item_data );

          if( lineItemData.hire_period != undefined && lineItemData.hire_period != undefined != '' && lineItemData.hire_period != '0' ) {
            var finalPrice = (( filterPrice * filterQty ) * lineItemData.hire_period).toFixed(2);
            finalPrice = finalPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            return 'R' + finalPrice;
          } else {
            var finalPrice = (filterPrice * filterQty).toFixed(2);
            finalPrice = finalPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            return 'R' + finalPrice;
          }

        } else {

          var finalPrice = (filterPrice * filterQty).toFixed(2);
          finalPrice = finalPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
          return 'R' + finalPrice;

        }


      },
      fncFormatTotalNett(filterPrice, filterQty, filterDiscount, filterDiscountQty, item) {

        if( item != undefined && item != 'undefined' && ( item.code == '000000000000751223' || item.code == '751223' ) ) {
          var lineItemData = JSON.parse( item.line_item_data );

          if( lineItemData.hire_period != undefined && lineItemData.hire_period != undefined != '' && lineItemData.hire_period != '0' ) {
            var totalGross = ((filterPrice * filterQty) * lineItemData.hire_period).toFixed(2);
          } else {
            var totalGross = (filterPrice * filterQty).toFixed(2);
          }

        } else {
          var totalGross = (filterPrice * filterQty).toFixed(2);
        }

        var totalDiscount = (filterDiscount * filterDiscountQty).toFixed(2);

        var finalPrice = parseFloat(totalGross) - parseFloat(totalDiscount);
            finalPrice = finalPrice.toFixed(2);

        var nettValue = finalPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

        if( nettValue.includes('.') ) {
          var splitValue = nettValue.split('.');
          if( splitValue[1].length > 1 ) {
            return 'R' + nettValue;
          } else {
            return 'R' + nettValue + '0';
          }
        } else {
          return 'R' + nettValue + '.00';
        }

        //return 'R' + parseFloat(nettValue).toFixed(2);

        //console.log( totalGross + ' = ' + totalDiscount + ' - ' + finalPrice );

        //totalGross = totalGross.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

        /*var finalPrice = (parseFloat(parseFloat(filterPrice) - parseFloat(filterDiscount)).toFixed(2) * filterQty).toFixed(2);
        var nettValue = finalPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return 'R' + nettValue;*/
      },
      fncCalculateVat() {
        var vat = 0.15;
        if (this.singleQuoteData.quote.tax_rate != '' && this.singleQuoteData.quote.tax_rate != undefined ) {
          vat = this.singleQuoteData.quote.tax_rate / 100;
        }
        var totalVat = this.totalNett * vat;
        totalVat = Math.round(totalVat * 100) / 100;
        this.totalVat = totalVat;
        totalVat = totalVat.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return 'R' + totalVat;
      },
      fncFinalTotal() {
        if( this.objAuthorize.manufacturer != '385889803' && this.objAuthorize.manufacturer != '16777962' ) {

          var finalTotal = parseFloat(this.totalNett);
          finalTotal = finalTotal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
          
          return 'R' + finalTotal;          

        } else {
          
          var finalTotal = parseFloat(parseFloat(this.totalNett) + parseFloat(this.totalVat)).toFixed(2);
          finalTotal = finalTotal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
          
          return 'R' + finalTotal;

        }      
      },
      fncTotalNett() {
        var pkey_array = [];
        var parent_price_provided = [];
        for (var l in this.singleQuoteData.details) {

          if (this.singleQuoteData.details[l].linked_props != '') {
            var json = JSON.parse(this.singleQuoteData.details[l].line_item_data);
            if( this.singleQuoteData.details[l].linked_props ) {
              var linkedProps = this.singleQuoteData.details[l].linked_props.split(',');
            } else {
              var linkedProps = [];
            }

            for ( var l in linkedProps ) {
              parent_price_provided[linkedProps[l]] = json.price_provided;
            }
            pkey_array = pkey_array.concat(linkedProps);
          }
        }

        var totalNett = 0;

        if( this.isTallisman == true ) {

          for (var l in this.singleQuoteData.details) {

            var item = this.singleQuoteData.details[l];
            var filterPrice = item.price;
            var filterQty = item.quantity;

            if( item.code == '000000000000751223' || item.code == '751223' ) {

              var lineItemData = JSON.parse( item.line_item_data );

              if( lineItemData.hire_period != undefined && lineItemData.hire_period != undefined != '' && lineItemData.hire_period != '0' ) {
                var finalPrice = (( filterPrice * filterQty ) * lineItemData.hire_period);
                totalNett = totalNett + finalPrice;
              } else {
                var finalPrice = (filterPrice * filterQty);
                totalNett = totalNett + finalPrice;
              }

            } else {
              var finalPrice = (filterPrice * filterQty);
              totalNett = totalNett + finalPrice;
            }

          }

        } else {
          for (var l in this.singleQuoteData.details) {
            var line_data = JSON.parse(this.singleQuoteData.details[l].line_item_data);
            if (pkey_array.length == 0 ) {
              //var addPrice = (parseFloat(parseFloat(this.singleQuoteData.details[l].price) - parseFloat(this.singleQuoteData.details[l].discount)).toFixed(2) * this.singleQuoteData.details[l].quantity_calc).toFixed(2);
              var addPrice = (parseFloat(parseFloat(this.singleQuoteData.details[l].price) - parseFloat(this.singleQuoteData.details[l].discount)) * this.singleQuoteData.details[l].quantity_calc);
              totalNett = totalNett + parseFloat(addPrice);
            } else {
              if (pkey_array.indexOf(this.singleQuoteData.details[l].p_key.toString()) == -1 || (parent_price_provided[this.singleQuoteData.details[l]['p_key']] != null && parent_price_provided[this.singleQuoteData.details[l]['p_key']] == 1)) {
                //var addPrice = (parseFloat(parseFloat(this.singleQuoteData.details[l].price) - parseFloat(this.singleQuoteData.details[l].discount)).toFixed(2) * this.singleQuoteData.details[l].quantity_calc).toFixed(2);
                var addPrice = (parseFloat(parseFloat(this.singleQuoteData.details[l].price) - parseFloat(this.singleQuoteData.details[l].discount)) * this.singleQuoteData.details[l].quantity_calc);
                totalNett = totalNett + parseFloat(addPrice);
              } else if ( line_data.parent_prop == '' ) {
                //var addPrice = (parseFloat(parseFloat(this.singleQuoteData.details[l].price) - parseFloat(this.singleQuoteData.details[l].discount)).toFixed(2) * this.singleQuoteData.details[l].quantity_calc).toFixed(2);
                var addPrice = (parseFloat(parseFloat(this.singleQuoteData.details[l].price) - parseFloat(this.singleQuoteData.details[l].discount)) * this.singleQuoteData.details[l].quantity_calc);
                totalNett = totalNett + parseFloat(addPrice);
              }
            }
          }
        }



       /* var totalNett = 0;
        for (var k in this.singleQuoteData.details) {
          var addPrice = (parseFloat(parseFloat(this.singleQuoteData.details[k].price) - parseFloat(this.singleQuoteData.details[k].discount)).toFixed(2) * this.singleQuoteData.details[k].quantity_calc).toFixed(2);
          totalNett = totalNett + parseFloat(addPrice);
        }*/
        this.totalNett = totalNett.toFixed(2);
        totalNett = totalNett.toFixed(2);

        /*if( this.objAuthorize.manufacturer == '16777962') {
          totalNett = totalNett / 1.15;
        }*/

        totalNett = totalNett.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return 'R' + totalNett;
      },
      fncShowSpec( spec, num ) {
        var addedSpecs = [];
        var addedFinalSpecs = [];
        for( var s in spec ) {
          //addedSpecs.push( spec[s].spec );
          addedSpecs[spec[s].spec] = '';
        }
        var strReturn = '';
        for( var a in addedSpecs ) {
          strReturn += a;
        }
        return strReturn;
        /*if( num == 0 ) {
          return spec;
        } else {
          return '';
        }*/
        /*if( this.addedSpecs[spec] == '' || this.addedSpecs[spec] == undefined || this.addedSpecs[spec] == null ) {
          this.addedSpecs.push(spec);
          return spec;
        }*/
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'departmentList'
        //'singleQuoteData'
      ])
    },
    beforeMount() {

      this.newSingleQuoteData.details = this.globalModalParams.quoteDetails;
      this.newSingleQuoteData.attachment = this.globalModalParams.quoteAttachments;
      this.newSingleQuoteData.quote = this.globalModalParams.quote;

      this.singleQuoteData = this.newSingleQuoteData;

      this.lineData = JSON.parse(this.singleQuoteData.quote.product_codes);

      if( this.lineData != '' ) {
        this.lineData = this.lineData.split('|||');
        this.lineData = this.lineData[0];
        this.lineData = JSON.parse( this.lineData );
      }

      var lineDataCount = Object.keys(this.lineData).length;
          lineDataCount = lineDataCount - 25;
      this.productCount = ( lineDataCount / 6 );

    },
    mounted() {

      for( var d in this.departmentList ) {
        if( this.departmentList[d].id == this.singleQuoteData.quote.departmentId ) {
          if( this.departmentList[d].is_special == true ) {
            this.isTallisman = true;
          }
        }
      }

      for (var i in this.singleQuoteData.details) {
        if ( this.singleQuoteData.details[i].linked_props && this.singleQuoteData.details[i].linked_props != '' ) {
          var objProps = this.singleQuoteData.details[i].linked_props.split(',');
          this.linkedProps = this.linkedProps.concat(objProps);
        }
      }
    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
